import React from "react";

//UI Material
import { Card, Divider, Grid, Stack, Typography } from "@mui/material";

export default function ConnectivityDeviceInfo({ data, getDeviceData }) {
  return (
    <Card raised sx={{ height: "100%" }}>
      <Grid container sx={{ padding: "20px" }} spacing={1}>
        <Grid item xs={12} align="left">
          <Typography variant="h6" fontWeight="bold">
            Información del dispositivo
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Divider flexItem />
        </Grid>
        <Grid item xs={12} align="left">
          <Typography variant="h7" fontWeight="bold" color="secondary">
            Especificaciones del dispositivo
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Descripción
            </Typography>
            <Typography variant="body2">{data.description}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Marca
            </Typography>
            <Typography variant="body2">{data.brand}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Modelo
            </Typography>
            <Typography variant="body2">{data.model}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              IMEI
            </Typography>
            <Typography variant="body2">{data.IMEI}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              SIM
            </Typography>
            <Typography variant="body2">{data.SIM}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              MAC Address
            </Typography>
            <Typography variant="body2">{data.macAddress}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Dirección IP
            </Typography>
            <Typography variant="body2">{data.accessIP}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Divider flexItem />
        </Grid>
        <Grid item xs={12} align="left">
          <Typography variant="h7" fontWeight="bold" color="secondary">
            Seguridad del dispositivo
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              SSID
            </Typography>
            <Typography variant="body2">{data.SSID}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Contraseña de administrador
            </Typography>
            <Typography variant="body2">{data.adminPass}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Contraseña
            </Typography>
            <Typography variant="body2">{data.password}</Typography>
          </Stack>
        </Grid>
      </Grid>
    </Card>
  );
}
